export class PageHelper {
    static removePage(pages, pageId) {
        return pages?.filter((page) => page.id !== pageId);
    }
    static renamePage(pages, pageId, name) {
        return pages?.map((page) => (page.id === pageId ? { ...page, name } : page));
    }
    static normalizeDrippingConfig(config) {
        if (!config)
            return null;
        const liberation = config.liberation?.type === 'BY_QUIZ'
            ? {
                ...config.liberation,
                quizId: config.liberation.pageId
            }
            : config.liberation;
        return {
            ...config,
            liberation
        };
    }
}
